import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.RuleTypeSection', {
    scheduleTypeText: 'Send report to these emails every',
    periodEveryDay: 'Every day',
    periodEveryWorkingDay: 'Every working day (Monday till Friday)',
    periodEveryWeekMonday: 'Every week — Monday',
    periodEveryMonthMondayOf4thWeek: 'Every month — Monday of every 4th week',
    periodEveryMonthLastMonday: 'Every month — last Monday of a month',
    periodEveryYearDecember25th: 'Every year on 25 December',
    periodCustom: 'Custom',
});
